import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  dialogButton: {
    margin: theme.spacing(0, 2),
    borderRadius: theme.spacing(0.5),
    border: 'none',
    padding: theme.spacing(1, 2),
  },
  like: {
    fill: theme.custom.palette.redBright,
  },
  emptyDialogPaper: {
    minHeight: '35vh',
    maxHeight: '35vh',
  },
  dialogPaper: {
    minHeight: '35vh',
    maxHeight: '70vh',
  },
  dialogContent: {
    paddingTop: theme.spacing(0),
    display: 'flex',
  },
  link: {
    cursor: 'pointer',
  },
  user: {
    marginBottom: theme.spacing(2),
  },
  avatar: {
    paddingLeft: theme.spacing(0),
  },
}));

export default useStyles;
